import { Component, OnInit } from '@angular/core';
import { DataStateChangeEvent, PageChangeEvent, PagerSettings, SelectableSettings } from '@progress/kendo-angular-grid';
import { DataResult, State,process, SortDescriptor } from '@progress/kendo-data-query';
import moment from 'moment';
import { ScreenListsService, Ps_Lst_Connections_Result, SharedDataService } from 'ngx-paf-common';

@Component({
  selector: 'app-lst-connexions',
  templateUrl: './lst-connexions.component.html',
  styleUrls: ['./lst-connexions.component.scss']
})
export class LstConnexionsComponent implements OnInit {

  
  constructor(
    private sharedDataSvc: SharedDataService,
    private screenListsSvc:ScreenListsService
  ) { }

  LstCnxs:Ps_Lst_Connections_Result[]=[];
  public gridDatas: DataResult;


  public state: State = {
    skip: 0,
    take: 100,  
    sort:  [{
      field: "DateLogin",
      dir: "desc",
    },
    {
      field: "Email",
      dir: "asc",
    }],
    // group:  [
    //   { field: "DateLogin" },
    //   { field: "Email" },
    //   { field: "Lastname" },
    //   { field: "CnxId" }
    //]
  };
  public pagerSettings:PagerSettings = {
    position: 'top',
    pageSizes: [20,50,100],
    previousNext: true,
    responsive: true,
    type:'numeric'
  }
  
  
  public selectableSettings: SelectableSettings = {
    checkboxOnly:false,
    mode: 'single',
    drag: false,
  }
  ngOnInit(): void {
    this.sharedDataSvc.RedirectToDefaultScreenIfNotAllowed('LST_CONNECTIONS');
    this.reloadConnections();
  }

  reloadConnections():void{
    this.sharedDataSvc.WindowLock();
    this.screenListsSvc.ConnexionsLists('EXTRANET').subscribe(results=> {
      this.sharedDataSvc.WindowUnlock();
      this.LstCnxs = results;
      this.refreshDataGrid();
    },
    reject=>{
      this.sharedDataSvc.alert(reject.error || JSON.stringify(reject));
    });
  }

  get canAccessScreen():boolean{
    return this.sharedDataSvc?.checkProfilAccessPafSettings('LST_CONNECTIONS');
  }

   
  pageChange({ skip, take }: PageChangeEvent): void {
    this.state.skip = skip;
    this.state.take = take;
    this.refreshDataGrid();
  }
  refreshDataGrid():void{
        this.gridDatas = process(this.LstCnxs,  this.state);
  }
  public dataStateChange(state: DataStateChangeEvent): void {
    state.group = this.state.group;
    this.state = state;
    this.refreshDataGrid();
  }

  public sortChange(sort: SortDescriptor[]): void {
    this.state.sort = sort;
    this.refreshDataGrid();
  }

  // Si 1 case cochée, sinon case non cochée
  checkNgClass(fieldValue: number): any {    
    return {
      'far': true,
      'fa-check-square': (fieldValue == 1),
      'fa-square': (fieldValue != 1),
    }
  }

  public getSupplierLink(item:any):string {
    if (!(item||{}).SupplierId) return '';
    return '/supplier-details/'+item.SupplierId+'/lst-connexions';
  }

  public GroupHeaderLib(cnxId:number): string {
    const item:Ps_Lst_Connections_Result =  this.LstCnxs.find(c=>c.CnxId==cnxId);
    if (!item) return '';
    return item.DateLogin.toLocaleDateString() +' ' + item.DateLogin.toLocaleTimeString() +' ' + item.Email;
    
  }
  get excelFilename():string {
    return 'Connexions-'+ moment().format('DD-MM-YYYY-HHmm') +'.xlsx'
  }

}
